import { getEnv } from '@luna/env';

import { clientOptionsFactory } from './settings/clientOptions';

clientOptionsFactory.set(() => ({ baseUrl: `${getEnv().apiGatewayUrl}dashboard` }));
